import { FileResponse } from 'types/Request';
import * as types from './types';

const initialState = {
  societyList: {
    status: 'IDLE',
    data: []
  },
  id: undefined,
  nameSociety: '',
  countrySociety: '',
  societyAddress: '',
  societyCity: '',
  societyZipCode: '',
  siren: '',
  firstname: '',
  lastname: '',
  address: '',
  zipCode: '',
  city: '',
  societyLegal: '',
  rcs: '',
  role: '',
  country: '',
  birthday: {
    day: '',
    month: '',
    year: ''
  },
  success: false,
  files: {
    idCardRecto: {
      status: 'IDLE',
      type: 'id_card_recto',
      file: null,
      error: null
    },
    idCardVerso: {
      status: 'IDLE',
      type: 'id_card_verso',
      file: null,
      error: null,
    },
    passport: {
      status: 'IDLE',
      type: 'passport',
      file: null,
      error: null,
    },
    homeCertificate: {
      status: 'IDLE',
      type: 'home_certificate',
      file: null,
      error: null,
    },
    operationalStatus: {
      status: 'IDLE',
      type: 'operational_status',
      file: null,
      error: null,
    },
    kbis: {
      status: 'IDLE',
      type: 'kbis',
      file: null,
      error: null,
    }
  },
};

type SocietyAction = {
  type: typeof types[keyof typeof types];
  payload?: Partial<types.SocietyState> | string | FileResponse;
};

export default function societyReducer(state = initialState, action: SocietyAction) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_SOCIETY_CHOOSE': {
      return {
        ...state,
        ...action.payload as types.SocietyState,
      };
    }
    case 'FETCH_SOCIETY_REQUEST': {
      return {
        ...state,
        societyList: {
          status: 'LOADING',
          data: []
        },
      };
    }
    case 'FETCH_SOCIETY_SUCCESS': {
      return {
        ...state,
        societyList: {
          status: 'SUCCESS',
          data: action.payload
        },
      };
    }
    case 'FETCH_SOCIETY_FAIL': {
      return {
        ...state,
        societyList: {
          status: 'FAIL',
          data: []
        },
      };
    }
    case 'CREATE_SOCIETY':
      return { ...state, isUploading: true };
    case 'CREATE_SOCIETY_SUCCESS':
      return { ...state, isUploading: false, success: true };
    case 'CREATE_SOCIETY_ERROR':
      return { ...state, isUploading: false, success: false };
    case 'UPLOAD_FILE_REQUEST':
      if (payload !== 'idCardRecto' && payload !== 'idCardVerso') return;
      return {
        ...state,
        files: {
          ...state.files,
          [payload]: {
            ...state.files[payload],
            status: 'LOADING'
          }
        }
      };
    case 'UPLOAD_FILE_SUCCEEDED':
      let fileNameSucceed = (payload as FileResponse)?.name
      if (fileNameSucceed !== 'idCardRecto' && fileNameSucceed !== 'idCardVerso') return;
      return {
        ...state,
        files: {
          ...state.files,
          [fileNameSucceed]: {
            ...state.files[fileNameSucceed],
            status: 'SUCCESS',
            file: (payload as FileResponse)?.url
          }
        }
      };
    case 'UPLOAD_FILE_FAILED':
      let fileNameFailed = (payload as FileResponse)?.name;
      if (fileNameFailed !== 'idCardRecto' && fileNameFailed !== 'idCardVerso') return;
      return {
        ...state,
        files: {
          ...state.files,
          [fileNameFailed]: {
            ...state.files[fileNameFailed],
            status: 'ERROR',
            error: (payload as FileResponse)?.error,
          }
        }
      };
    case 'RESET_SOCIETY_FILE':
      if (payload !== 'idCardRecto' && payload !== 'idCardVerso') return;
      return {
        ...state,
        files: {
          ...state.files,
          [payload]: {
            ...state.files[payload],
            status: 'IDLE',
            error: null,
            file: null,
          }
        }
      };
    case 'SET_SOCIETY':
      return {
        ...state,
        ...payload as types.SocietyState,
      };
    case 'UPDATE_NAME_SOCIETY':
      return { ...state, nameSociety: payload };
    case 'UPDATE_COUNTRY_SOCIETY':
      return { ...state, countrySociety: payload };
    case 'UPDATE_SIREN':
      return { ...state, siren: payload };
    case 'UPDATE_ROLE':
      return { ...state, role: payload };
    case 'UPDATE_LEGAL_SOCIETY':
      return { ...state, societyLegal: payload };
    case 'UPDATE_REPRESENTATIVE_FIRSTNAME':
      return { ...state, firstname: payload };
    case 'UPDATE_REPRESENTATIVE_LASTNAME':
      return { ...state, lastname: payload };
    case 'UPDATE_REPRESENTATIVE_ADDRESS':
      return { ...state, address: payload };
    case 'UPDATE_REPRESENTATIVE_ZIP_CODE':
      return { ...state, zipCode: payload };
    case 'UPDATE_REPRESENTATIVE_CITY':
      return { ...state, city: payload };
    case 'UPDATE_SOCIETY_ADDRESS':
      return { ...state, societyAddress: payload };
    case 'UPDATE_SOCIETY_ZIP_CODE':
      return { ...state, societyZipCode: payload };
    case 'UPDATE_SOCIETY_CITY':
      return { ...state, societyCity: payload };
    case 'UPDATE_REPRESENTATIVE_COUNTRY':
      return { ...state, country: payload };
    case 'UPDATE_REPRESENTATIVE_BIRTHDAY':
      return { ...state, birthday: payload };
    case 'UPDATE_RCS':
      return { ...state, rcs: payload };
    default:
      return state;
  }
}
